import { useState } from "react";
import {
  NXAnalytics,
  NXCoupon,
  NXCustomer,
  NXDashboard,
  NXEmv,
  NXPlugin,
  NXProductBag,
  NXShoppingCart,
  NXUser,
  NXSetting,
  NXHelp,
  NXStock,
  NXCartCheck,
  NXTheme,
} from "../../icons";

export type MenuItemType = {
  name: string;
  url?: string;
  icon: JSX.Element;
  count?: number,
  subMenu?: any[];
};

const useMenuItems = () => {
  const [menuItems] = useState<MenuItemType[]>([
    {
      name: "Home",
      url: "/dashboard",
      icon: <NXDashboard  />,
    },
    {
      name: "Catalog",
      icon: <NXProductBag />,
      // count: 12,
      subMenu: [
        {
          name: "Products",
          url: "/dashboard/products"
        },
        {
          name: "Inventory",
          url: "/dashboard/inventory"
        },
        {
          name: "Categories",
          url: "/dashboard/products/categories"
        },
        {
          name: "Color",
          url: "/dashboard/products/color"
        },
        {
          name: "Product Type",
          url: "/dashboard/products/product-type"
        },
        {
          name: "Collection",
          url: "/dashboard/products/collection"
        },
        {
          name: "Supplier",
          url: "/dashboard/products/supplier"
        },
      ],
    },
    {
      name: "Analytics",
      url: "/dashboard/analytics",
      icon: <NXAnalytics />,
    },
    {
      name: "Orders",
      icon: <NXShoppingCart  />,
      subMenu: [
        {
          name: "Order",
          url: "/dashboard/orders"
        },
        {
          name: "Return Request",
          url: "/dashboard/orders/return-request"
        },
        {
          name: "Abandoned Cart",
          url: "/dashboard/orders/abandonedcart"
        },
      ],
    },
    // {
    //   name: "EMV",
    //   url: "/dashboard/emv",
    //   icon: <NXEmv />,
    // },
    {
      name: "Purchase",
      url: "/dashboard/purchase-orders/",
      icon: <NXCartCheck className="w-[23px] h-[24px]"/>,
    },
    {
      name: "Plugin",
      url: "/dashboard/plugin",
      icon: <NXPlugin />,
    },
    // {
    //   name: "eCommerce",
    //   url: "/dashboard/ecommerce",
    //   icon: <NXEcommerce />,
    // },
    {
      name: "Customers",
      icon: <NXCustomer />,
      url: "/dashboard/customers",
    },
    {
      name: "Stocks",
      icon: <NXStock />,
      subMenu: [
        {
          name: "Stocks",
          url: "/dashboard/stocks"
        },
        {
          name: "Stock Reservation",
          url: "/dashboard/stocks/reservation"
        },
        {
          name: "Stock Transfer",
          url: "/dashboard/stocks/transfers"
        },
      ]
    },
    {
      name: "Promo",
      icon: <NXCoupon />,
      subMenu: [
        {
          name: "Promocode",
          url: "/dashboard/promocodes"
        },
        {
          name: "Promocode Usage",
          url: "/dashboard/promocodes/usage"
        },
      ],
    },
    {
      name: "International",
      icon: <NXEmv />,
      subMenu: [
        {
          name: "Translations",
          url: "/dashboard/translations",
        },
        {
          name: "Exchange Rate",
          url: "/dashboard/exchangerate",
        },
        // { Not for MVP
        //   name: "Exchange Rate",
        //   url: "/dashboard/exchangerate",
        // },
      ],
    },
    {
      name: "Staff & ACL",
      url: "/dashboard/user-management",
      icon: <NXUser />,
    },
    {
      name: "Settings",
      url: "/dashboard/settings/",
      icon: <NXSetting />,
    },
    {
      name: "Theme",
      icon: <NXTheme />,
      subMenu: [
        {
          name: "Page",
          url: "/dashboard/pages"
        },
      ]
    },
    {
      name: "Get Help",
      url: "/get-help",
      icon: <NXHelp />
    },
  ]);

  return menuItems;
};

export default useMenuItems;
